import type { IAddress } from '../client/client.entity';
import type { IPlanningItemEntity } from './planning-item.entity';
import type { MovetexSyncResponse } from '../movetex/movetex-results.entity';

// Value + merged type (see MaintenancePeriodUnit): the generated api client re-exports these names
// as runtime values, so a bare type alias would blank the portal at module load.
export const PlanningItemDeliveryAddressAction = {
    select: 'select',
    create: 'create',
    correct: 'correct',
} as const;
export type PlanningItemDeliveryAddressAction =
    (typeof PlanningItemDeliveryAddressAction)[keyof typeof PlanningItemDeliveryAddressAction];

// Flat on purpose: tsoa (throw-on-extras) validates object unions poorly and the generated client
// would get anyOf wrapper types. The manager enforces what each action requires.
export interface PlanningItemDeliveryAddressChange {
    action: PlanningItemDeliveryAddressAction;
    // select: MAIN_ADDRESS_ID or the id of a live delivery address of the client
    delivery_address_id?: string;
    // create / correct: the address value; id and deleted are ignored
    address?: IAddress;
}

// What happened to the client's own address record: linked (select), created, updated (correct,
// linked record patched) or unchanged (correct on an item whose link no longer resolves).
export const ClientAddressOutcome = {
    linked: 'linked',
    created: 'created',
    updated: 'updated',
    unchanged: 'unchanged',
} as const;
export type ClientAddressOutcome = (typeof ClientAddressOutcome)[keyof typeof ClientAddressOutcome];

export interface PlanningItemDeliveryAddressChangeResult {
    planning_item: IPlanningItemEntity;
    client_address: { id: string | null; outcome: ClientAddressOutcome };
    // null when the item is not Movetex-managed
    movetex: MovetexSyncResponse | null;
    // null when the item has no assigned calendar item
    outlook_event: 'queued' | null;
}
